import { render, staticRenderFns } from "./pres.vue?vue&type=template&id=f643b2b4&scoped=true&"
import script from "./pres.vue?vue&type=script&lang=ts&"
export * from "./pres.vue?vue&type=script&lang=ts&"
import style0 from "./pres.vue?vue&type=style&index=0&id=f643b2b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f643b2b4",
  null
  
)

export default component.exports